export default __webpack_public_path__ + "static/media/svg-2.83ea3bd3.svg";